import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Users, Heart, Stethoscope, ShoppingCart, PawPrint, Star } from "lucide-react";
import Layout from "../../components/Layout";

import PetOwnerList from "./Petowner/PetOwner";

import VendorPage from "./VendorsPage";
import PetsList from "./Pets/Pets";
import RecommendedDoctorsList from "./RecommendedDoctorsList";
import VeterinarianList from "./Veterinarians/vetenerian";
import ServiceProviderList from "./Serviceprovider/serviceprovider";

const roles = [
  { label: "Parents", value: "parent", icon: <Users className="w-4 h-4 mr-2" /> },
  { label: "Pets", value: "Pets", icon: <PawPrint className="w-4 h-4 mr-2" /> },
  { label: "Veterinarians", value: "veterinarian", icon: <Stethoscope className="w-4 h-4 mr-2" /> },
  { label: "Service Providers", value: "service_provider", icon: <Heart className="w-4 h-4 mr-2" /> },
  { label: "Vendors", value: "vendor", icon: <ShoppingCart className="w-4 h-4 mr-2" /> },
  { label: "Recommended Veterinarians / Service Providers", value: "recommended_doctors", icon: <Star className="w-4 h-4 mr-2" /> },
];

export default function UsersPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const initialRole = queryParams.get("role") || "parent";

  const [selectedRole, setSelectedRole] = useState<string>(initialRole);

  useEffect(() => {
    const role = queryParams.get("role");
    if (role && roles.some(r => r.value === role)) {
      setSelectedRole(role);
    } else {
      setSelectedRole("parent");
    }
  }, [location.search]);

  const renderUserList = () => {
    switch (selectedRole) {
      case "veterinarian":
        return <VeterinarianList />;
      case "parent":
        return <PetOwnerList />;
      case "service_provider":
        return <ServiceProviderList />;
      case "vendor":
        return <VendorPage />;
      case "Pets":
        return <PetsList />;
      case "recommended_doctors":
        return <RecommendedDoctorsList />;
      default:
        return <p>Select a role to see the users.</p>;
    }
  };

  return (
    <Layout>
      <div className="p-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex gap-3">
            {roles.map((r) => (
              <button
                key={r.value}
                onClick={() => {
                  setSelectedRole(r.value);
                  navigate(`?role=${r.value}`);
                }}
                className={`flex items-center px-4 py-2 rounded-lg border text-sm font-medium ${selectedRole === r.value
                  ? "bg-black text-white"
                  : "bg-white hover:bg-gray-100"
                  }`}
              >
                {r.icon}
                {r.label}
              </button>
            ))}
          </div>
        </div>

        <div>{renderUserList()}</div>
      </div>
    </Layout>
  );
}
